import { api } from "@/lib/api";

// The server's current snapshot and explicit confirmation are both required.
// Never silently retry a stale household or reinterpret a failed save as success.
export async function saveSharingTreeRoster(method, path, body) {
  try {
    return await api[method](path, body);
  } catch (error) {
    const detail = error?.response?.data?.detail;
    if (error?.response?.status !== 409 || detail?.code !== "sharing_tree_removal_confirmation") throw error;
    const members = detail.members || [];
    const names = members.map(m => `${m.name || "Unnamed member"} (${m.toy_count} toy requests${m.has_sizes ? ", clothing sizes" : ""})`).join("\n");
    if (!window.confirm(`${detail.message}\n\n${names}\n\nPermanently remove these saved requests? Cancel to combine duplicate children first.`)) throw new Error("Removal cancelled. Saved requests were not removed.");
    return api[method](path, { ...body, confirmed_removals: members.map(m => m.id) });
  }
}
